export enum PriceVisibilityType {
    AUTO = 1,
    ALWAYS = 2,
    NEVER = 3
}
export enum PriceVisibilityType {
    AUTO = 1,
    ALWAYS = 2,
    NEVER = 3
}
